import React from "react";
import { FieldProps } from "formik";
import cx from "clsx";
import ReactNumberFormat from "react-number-format";

export interface PriceInputProps extends FieldProps {
  label?: string;
  placeholder?: string;
}

export default ({ label, placeholder = "+998", field, form }: PriceInputProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const inputClasses = cx("form-control", {
    "is-invalid": touched && error,
    "is-valid": touched && !error
  });
  const feedbackClasses = cx({
    "invalid-feedback": touched && error,
    "valid-feedback": touched && !error
  });

  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      <ReactNumberFormat
        className={inputClasses}
        placeholder={placeholder}
        displayType="input"
        thousandSeparator=" "
        value={field.value}
        onValueChange={({ value }) => form.setFieldValue(field.name, value)}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
      {touched && error && <div className={feedbackClasses}>{error}</div>}
    </div>
  );
};
